import { useEffect } from "react";
import { router } from "@/routes";
import { initClarity } from "@/utils/clarity";

export function ClarityProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Initialize Clarity once
    initClarity();
    console.log("Clarity initialized:", router.state.location.pathname);

    // Listen for navigation changes
    const unlisten = router.subscribe(() => {
      console.log("Clarity reapplied:", router.state.location.pathname);
    });

    return () => unlisten();
  }, []);

  return <>{children}</>;
}
